import { styled } from "@mui/material/styles";

export const SlideButtonBox = styled("div")(() => ({
  display: "flex",
  gap: "16px",
  justifyContent: "center",
  padding: "8px",
}));
